import { DATEPICKER_FORMATS } from './types';
function padStart(value) {
    return String(value).padStart(2, '0');
}
var helpers = {
    getDateParts: function (value) {
        var rawParts = value.replace(/_/g, '').split('.');
        return rawParts.map(function (rawVal, ind) {
            if (ind === rawParts.length - 1) {
                if (rawVal.length !== 4) {
                    return undefined;
                }
            }
            return rawVal.length !== 0 ? Number(rawVal) : undefined;
        });
    },
    isStringValidAsDate: function (date) {
        return !isNaN(Date.parse(date));
    },
    isInputStringValidAsDate: function (inputString, format) {
        var dateParts = helpers.getDateParts(inputString);
        if (dateParts.includes(undefined)) {
            return false;
        }
        if (format === DATEPICKER_FORMATS.DD_MM_YYYY) {
            return helpers.isStringValidAsDate("".concat(dateParts[2], "-").concat(padStart(dateParts[1]), "-").concat(padStart(dateParts[0])));
        }
        return helpers.isStringValidAsDate("".concat(dateParts[1], "-").concat(padStart(dateParts[0])));
    },
    makeISOStringFromInputString: function (inputString, format) {
        if (inputString.length === 0) {
            return undefined;
        }
        if (!helpers.isInputStringValidAsDate(inputString, format)) {
            return null;
        }
        var dateParts = helpers.getDateParts(inputString);
        var date;
        if (format === DATEPICKER_FORMATS.DD_MM_YYYY) {
            var day = dateParts[0], month = dateParts[1], year = dateParts[2];
            date = new Date(Date.UTC(year, month - 1, day));
        }
        else {
            var month = dateParts[0], year = dateParts[1];
            date = new Date(Date.UTC(year, month - 1, 1));
        }
        return date.toISOString();
    },
    makeInputStringFromISOString: function (ISOString, format) {
        var date = new Date(ISOString);
        var month = padStart(date.getUTCMonth() + 1);
        var year = padStart(date.getUTCFullYear());
        var result = "".concat(month, ".").concat(year);
        if (format === DATEPICKER_FORMATS.DD_MM_YYYY) {
            var day = padStart(date.getUTCDate());
            return "".concat(day, ".").concat(result);
        }
        return result;
    },
};
export default helpers;
